import React, { FC, useEffect, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Term from './Term';
import TermsDto from '@domain/rs/terms/TermsRs';

import classnames from 'classnames/bind';
import styles from './terms.module.scss';
const cx = classnames.bind(styles);

interface ITermListProps {
  termList: TermsDto[];
  checkStatus: boolean[];
  onCheck: (args: { idx: number }) => void;
  openStatus: boolean[];
  onOpen: (args: { idx: number }) => void;
}

const TermList: FC<ITermListProps> = ({ termList, checkStatus, onCheck, openStatus, onOpen }) => {
  return (
    <>
      {termList.map((term, idx) => (
        <div key={term.sn} className={cx('termsWrap')}>
          <Term
            isChecked={checkStatus[idx]}
            {...term}
            onClick={() => onCheck({ idx })}
            isOpen={openStatus[idx]}
            onOpen={() => onOpen({ idx })}
          />
        </div>
      ))}
    </>
  );
};

interface ITermsProps {
  termList?: TermsDto[];
}

const Terms: FC<ITermsProps> = ({ termList = [] }) => {
  const { control } = useFormContext();
  const getInitialState = (status = false) => {
    return Array.from({ length: termList?.length ?? 0 }, () => status);
  };

  const [checkStatus, setCheckStatus] = useState(getInitialState());

  const { field: checkStatusField } = useController({
    name: 'checkStatus',
    control,
  });

  useEffect(() => {
    if (checkStatus) {
      checkStatusField.onChange(checkStatus);
    }
  }, [checkStatus]);

  const onCheck = ({ idx }: { idx: number }) => {
    setCheckStatus((prevCheckStatus) => {
      const postCheckStatus = prevCheckStatus;
      postCheckStatus[idx] = !prevCheckStatus[idx];
      return [...postCheckStatus];
    });
  };

  // 약관 open/close 관련 작업
  const [openStatus, setOpenStatus] = useState(getInitialState());
  const getOpenStatus = (status: boolean[]) => status.every(() => false);
  const onOpen = ({ idx }: { idx: number }) => {
    const postOpenStatus = getInitialState(getOpenStatus(openStatus));

    postOpenStatus[idx] = !openStatus[idx];
    setOpenStatus(postOpenStatus);
  };

  if (!termList?.length) return null;

  return (
    <div className={cx('termsArea')}>
      <TermList
        termList={termList}
        checkStatus={checkStatus}
        onCheck={onCheck}
        openStatus={openStatus}
        onOpen={onOpen}
      />
    </div>
  );
};

export default Terms;
